import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { initializeTheme } from './hooks/use-appearance';
import { setupInertiaErrorHandling } from './inertia-error-handler';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
  title: (title) => (title ? `${title} | ${appName}` : appName),
  resolve: (name) =>
    resolvePageComponent(
      `./pages/${name}.tsx`,
      import.meta.glob('./pages/**/*.tsx')
    ),
  setup({ el, App, props }) {
    const root = createRoot(el);

    // 🔹 Pasamos la sesión compartida desde Laravel
    // TypeScript "confía" en nosotros
    const session = props.initialPage.props.session as { lifetime: number } | undefined;

    setupInertiaErrorHandling(session);

    root.render(<App {...props} />);
  },
  progress: {
    color: '#4B5563',
  },
});

// Dark/Light mode
initializeTheme();
